export default function createReducer(initialState, handlers) {
  return function reducer(state, action, allState, createEvent) {
    if (action && handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action.payload, { action, createEvent, state: allState });
    } else {
      return state || initialState;
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/utils/createReducer.js